var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 51 68",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.5 4c-10.767 0-19.5 8.778-19.5 19.6 0 14.7 19.5 36.4 19.5 36.4s19.5-21.7 19.5-36.4c0-10.822-8.733-19.6-19.5-19.6z",
    fill: "#049c47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.471 24.906c.007-.612.503-1.107 1.115-1.107h14.821c.387 0 .7-.315.7-.704v-7.585c0-.117.092-.208.208-.208h5.057c.44 0 .838.258 1.017.661l2.49 4.629c.004.007.007.014.011.017.063.145.095.301.095.457l-.06 8.84c-.011.619-.507 1.114-1.119 1.114h-.161c-.117 0-.211-.095-.211-.212 0-2.072-1.671-3.752-3.732-3.752s-3.735 1.68-3.735 3.752c0 .117-.095.212-.211.212h-1.161c-.116 0-.211-.095-.211-.212 0-2.072-1.671-3.752-3.732-3.752-1.34 0-2.514.711-3.172 1.775-.081.131-.267.134-.352.004-.665-1.029-1.818-1.708-3.13-1.708-2.061 0-3.732 1.679-3.732 3.752 0 .031 0 .06.004.092-.486-.149-.841-.605-.834-1.143l.035-4.922zm17.903-4.205c0 .191.14.343.313.343l5.328.018c.176 0 .317-.152.317-.343v-.318c0-.113-.022-.223-.067-.322l-1.674-3.211c-.12-.279-.387-.456-.683-.456h-2.972c-.478 0-.562.035-.562.583z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.698 27.905c1.636 0 2.958 1.333 2.958 2.974 0 1.644-1.326 2.974-2.958 2.974s-2.958-1.334-2.958-2.974c0-1.641 1.326-2.974 2.958-2.974zm0 4.02c.574 0 1.041-.466 1.041-1.046 0-.577-.464-1.047-1.041-1.047-.573 0-1.041.467-1.041 1.047.004.58.468 1.046 1.041 1.046z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.666 27.905c1.636 0 2.958 1.333 2.958 2.974 0 1.644-1.326 2.974-2.958 2.974-1.635 0-2.958-1.334-2.958-2.974 0-1.641 1.326-2.974 2.958-2.974zm0 4.02c.574 0 1.041-.466 1.041-1.046 0-.577-.464-1.047-1.041-1.047-.573 0-1.041.467-1.041 1.047s.468 1.046 1.041 1.046z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.998 27.926c1.635 0 2.958 1.333 2.958 2.974 0 1.644-1.326 2.974-2.958 2.974s-2.958-1.333-2.958-2.974c0-1.645 1.326-2.974 2.958-2.974zm0 4.021c.573 0 1.041-.467 1.041-1.047 0-.577-.464-1.047-1.041-1.047-.573 0-1.041.467-1.041 1.047.003.576.468 1.047 1.041 1.047z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.18 17.556c0-2.208-1.792-4-4-4h-9.181c-2.208 0-4 1.792-4 4v1.777c0 2.208 1.792 4 4 4h9.181c2.208 0 4-1.792 4-4z",
    fill: "#fffdfd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.3f4496fc643c012559e3d5b78ced7f61.svg";
export { ForwardRef as ReactComponent };